<template>
    <div>
        <a-layout style="background:#fff;">
            <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
                <div style="display:flex; justify-content: space-between;">
                    <p style="font-weight:bolder;font-size:20px"> Zhulia Seller </p>
                    <!-- <div v-show="displayProgressBar" class="progress">
                        <a-progress 
                        :percent="displayPercent" 
                        :strokeColor="progressColor"
                        />
                    </div> -->
                    <a @click="handlleLogout" style="color:#98c14b">Exit</a>
                </div>
            </a-layout-header>
            <a-layout-content :style="{ padding: '0 50px', marginTop: '64px', backgroundColor:'#f0f2f5' , height: '100%'}">
                <div>
                    <h3 class="title">Let's Setup Your Catalog</h3>
                    <p class="description">Now that you've signed in, let's setup your shop by knowing what kind of products you will be selling on Zhulia </p>
                </div>
                <div style="display: grid;">
                    <div style="border: #ccc;background: #418a49;line-height: 62px;margin-left: 155px;margin-right: 155px;margin-top:40px;">
                        <h3 style="text-align:center; color:#fff;">Select Product Group</h3>
                    </div>
                    <div style="background: #fff;margin-left: 155px;margin-right: 155px;">
                        <div style="padding: 20px">
                            <a-spin :spinning="loading">
                                <a-card>
                                    <div v-for="category in categories" :key="category.id" @click="showCategoriesModal(category)" >
                                        <category-card @spinner="showSpinner" :selectedCategory="activeItem" :category="category"></category-card>
                                    </div>
                                </a-card>
                            </a-spin>
                        </div>
                    </div>
                </div>
                <div style="display:flex;justify-content: center;padding:50px;">
                    <a-button @click="redirectToDashboard" style="background: #418a49;height:45px;color:#fff;width:256px;">
                        Continue to Dashboard
                    </a-button>
                </div>
            </a-layout-content>
        </a-layout>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
// const plainOptions = ['Apple', 'Pear', 'Orange'];
// const defaultCheckedList = ['Apple', 'Orange'];
import CategoryCard from  './CategoryCard'
    export default {
        name: "SetupShop",
        components:{
            CategoryCard
        },
         data() {
            return {
                categories: [],
                loading: false,
                activeItem: {},
            };
        },
        methods:{
             ...mapActions(['logout','getProductGroups']),
            handlleLogout(){
                this.logout();
            },
        
            showSpinner(value){
                this.loading = value;
            },
            showCategoriesModal(category){
                this.activeItem = category
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            redirectToDashboard(){
                this.showSuccessAlert("Yaay, Onboarding Completed Successfully");
                this.$router.push(`/overview`).catch(()=>{});
            },
            getProductGrps(){
                this.loading =  true;
                this.getProductGroups().then(response => {
                    if(response.status === 200){
                        this.loading = false;
                        this.categories = response.data.data;
                    }else{
                        this.loading = false;
                        this.showErrorAlert("Something went wrong");
                    }
                },error => {
                    this.loading = false;
                    console.log("Error | ", error)
                    this.showErrorAlert("Something went wrong");
                })
            }
        },
        created(){
            if(this.getProductGrps){
                this.getProductGrps();
            }
        }
    }
</script>

<style scoped>

.ant-layout-header{
    background: #fff;
    box-shadow: 0px 0px 6px;
}
.title{
    margin: 0 auto;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #000000;
    padding-top: 20px;
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.active{
    background: #418a49; 
}

.active > h4{
    color:#fff;
}

.description{
    margin: 0 auto;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
}

.img_size{
    width: 50px;
    height: 50px;
}
</style>